
import PropTypes from 'prop-types'

import PostComparisons from '../components/PostComparisons'
import ChartLineSection from '../components/ChartLineSection'
import ContentInfo from './ContentInfo'
import MainMetrics from './MainMetrics'

const TiktokUI = ({ data }) => {
    const contentInfoProps = {
        pic: data.pic,
        vendor: 'TikTok',
        channelName: data.channelName,
        channelPic: data.channelPic,
        date: data.published,
        url: data.url,
    }

    const mainMetricsProps = {
        likes: data.likes,
        comments: data.comments,
        views: data.views,
        shares: data.shares,
        viewRate: data.viewRate,
        engagement: data.engagement,
    }

    const postsProps = {
        posts: data.postsList,
        tabs: [
            { key: 'views', label: 'Views' },
            { key: 'likes', label: 'Likes' },
            { key: 'comments', label: 'Comments' },
            { key: 'engagement', label: 'Engagement' },
        ].filter(i => i !== null),
    }

    const postsTotals = data.postsList.reduce((acc, curr) => ({
        ...acc,
        likes: Number(((acc && acc.likes) || 0) + curr.likes),
        comments: Number(((acc && acc.comments) || 0) + curr.comments),
        views: Number(((acc && acc.views) || 0) + curr.views),
        shares: Number(((acc && acc.shares) || 0) + curr.shares),
    }), {})
    const postsLength = data.postsList.length

    const likesProps = {
        name: 'Likes',
        dataKey: 'likes',
        data: data.history,
        count: data.likes,
        avgCount: data.likes ? Number(postsTotals.likes / postsLength) : 0,
    }

    const commentsProps = {
        name: 'Comments',
        dataKey: 'comments',
        data: data.history,
        count: data.comments,
        avgCount: data.comments ? Number(postsTotals.comments / postsLength) : 0,
    }

    const viewsProps = {
        name: 'Views',
        dataKey: 'views',
        data: data.history,
        count: data.views,
        avgCount: data.views ? Number(postsTotals.views / postsLength) : 0,
    }

    const sharesProps = {
        name: 'Shares',
        dataKey: 'shares',
        data: data.history,
        count: data.shares,
        avgCount: data.shares ? Number(postsTotals.shares / postsLength) : 0,
    }

    return (
        <div>
            <div style={{ height: 15 }}/>
            <ContentInfo {...contentInfoProps}/>
            <div style={{ height: 30 }}/>
            <MainMetrics {...mainMetricsProps}/>
            <div style={{ height: 30 }}/>
            <PostComparisons {...postsProps}/>
            <div style={{ height: 30 }}/>
            <ChartLineSection {...viewsProps} icon={'Show'}/>
            <div style={{ height: 30 }}/>
            <ChartLineSection {...likesProps} icon={'Heart'}/>
            <div style={{ height: 30 }}/>
            <ChartLineSection {...commentsProps} icon={'Chat'}/>
            <div style={{ height: 30 }}/>
            <ChartLineSection {...sharesProps} icon={'Send'}/>
        </div>
    )
}

TiktokUI.propTypes = {
    data: PropTypes.object.isRequired,
}

export default TiktokUI
